import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ApiService } from './api.service';

export interface IStaffResponse {
  message: string;
  payload: IStaffPayload;
}

export interface IStaffPayload {
  content: IStaffContent[];
  page: IStaffPage;
}

export interface IStaffContent {
  id: string;
  fullName: string;
  phoneNumber: string;
  roles: string[];
  lastLoginAt: null;
  activatedAt: null;
  profilePicture: null;
}

export interface IStaffPage {
  size: number;
  number: number;
  totalElements: number;
  totalPages: number;
}

export interface ICreateStaffRequest {
  organizationId: string;
  fullName: string;
  email: string;
  phoneNumber: string;
  roleIds: string[];
  trackingLevel: string;
  assignedLocations: string;
}

@Injectable({
  providedIn: 'root',
})
export class StaffService {
  constructor(private api: ApiService) {}

  getStaffByOrganizationId(id: string): Observable<IStaffContent[]> {
    const params = new HttpParams().set('organizationId', id);
    return this.api
      .GET<IStaffResponse>('staff', { params })
      .pipe(map((response) => response.payload.content));
  }

  createStaff(staff: ICreateStaffRequest): Observable<IStaffContent> {
    const newStaffFormData = new FormData();
    const roleIds = staff.roleIds.join(',');
    newStaffFormData.append('organizationId', staff.organizationId);
    newStaffFormData.append('fullName', staff.fullName);
    newStaffFormData.append('email', staff.email);
    newStaffFormData.append('phoneNumber', staff.phoneNumber);
    newStaffFormData.append('roleIds', roleIds);
    newStaffFormData.append('trackingLevel', staff.trackingLevel);
    newStaffFormData.append('assignedLocations', staff.assignedLocations);
    newStaffFormData.append('gender', 'MALE');

    return this.api.POST<IStaffContent>('staff', newStaffFormData);
  }

  toggleAccountActivation(id: string, activated: boolean): Observable<IStaffResponse> {
    return this.api.PATCH<IStaffResponse>(`staff/${id}/toggle-active`, { activated });
  }
}
